/**
 * Created by mac on 1/6/23
 */

const MagicView = cleverapps.Layout.extend({
    ctor: function (magic) {
        this.magic = magic;

        // eslint-disable-next-line no-restricted-syntax
        const caption = cleverapps.UI.generateTTFText("Magic cards: ", cleverapps.styles.FONTS.EDITOR_BLUE_TEXT);

        const button = new cleverapps.UI.Button({
            text: "magic",
            width: cleverapps.styles.MagicView.button.width,
            height: cleverapps.styles.MagicView.button.height,
            onClicked: magic.regenerate.bind(magic)
        });

        const valueBlock = new IncDecBlock({
            value: magic.value,
            range: [0, 100],
            onChange: magic.setValue.bind(magic)
        });

        this._super([caption, valueBlock, button], {
            direction: cleverapps.UI.VERTICAL
        });

        magic.onRefreshListener = this.createListener(() => {
            valueBlock._setValue(magic.value, true);
        });
    }
});

cleverapps.styles.MagicView = {
    button: {
        width: 120,
        height: 60
    }
};